type TranslateFn = (key: string, params?: Record<string, unknown>) => string;

export function mockFreestandingBuildingsOptions(
  t: TranslateFn,
): ValueLabelPair<Capacity>[] {
  return [
    {
      label: "1",
      value: {
        min: 1,
        max: 1,
      },
    },
    {
      label: "2-3",
      value: {
        min: 2,
        max: 3,
      },
    },
    {
      label: "4-5",
      value: {
        min: 4,
        max: 5,
      },
    },
    {
      label: t("cksetup.wizard.rooms-step.orMoreThan", { count: 6 }),
      value: {
        min: 6,
        max: 2_147_483_647, //MAX_INT_32
      },
    },
  ];
}

export function mockRoomsAndLayoutsOptions(
  t: TranslateFn,
): ValueLabelPair<Capacity>[] {
  return [
    {
      label: "1-5",
      value: {
        min: 1,
        max: 5,
      },
    },
    {
      label: "6-10",
      value: {
        min: 6,
        max: 10,
      },
    },
    {
      label: "11- 20",
      value: {
        min: 11,
        max: 20,
      },
    },
    {
      label: t("cksetup.wizard.rooms-step.orMoreThan", { count: 21 }),
      value: {
        min: 21,
        max: 2_147_483_647, //MAX_INT_32
      },
    },
  ];
}
